/* Hero Link® email links → our forms. Instead of opening the visitor's email app, every link to a @herolink.com address
   goes to the form that handles it (all forms reach the team through the Worker, assets/hl-forms.js):
   - a form for that inbox on this same page (bulk / wholesale quote, warranty claim, training request): scroll to it
   - support@  → Contact page, Support & inquiries (reason picked from the page: orders, device help)
   - sales@ / orgs@ → the bulk quote form;  partners@ → Contact, Partnerships;  press@ / media@ → Contact, Press & media
   - sokeefe@ / careers@ / jobs@ → the careers application
   The mailto subject, if any, starts the message. Other addresses and "share by email" links are left alone, and a link
   can opt out with data-hl-mailto-keep. The rep and trainer dashboards use their own layouts and don't load this. */
(function () {
  var CONTACT = '/pages/contact', BULK = '/pages/bulk#hl-bulk-quote';
  var path = location.pathname.replace(/\/$/, '') || '/';
  // forms that can sit on the page you're on, by inbox
  var HERE = { support: ['#hl-warranty-claim'], sales: ['#hl-bulk-quote'], orgs: ['#hl-bulk-quote'] };

  function reasonFor() {
    if (/order-status|my-account|\/account|\/cart/.test(path)) return 'Order';
    if (/^\/products\/|\/pages\/(activate|help)|^\/(activate|help)$/.test(path)) return 'Device Support';
    return '';
  }
  function contact(topic, subject, reason) {
    var q = new URLSearchParams({ topic: topic });
    if (reason) q.set('reason', reason);
    if (subject) q.set('msg', subject);
    return CONTACT + '?' + q.toString() + '#hl-ct-' + topic + '-form';
  }
  // where a mailto: link should go instead, or '' to leave it alone
  function target(href) {
    var m = /^mailto:([^?]+)(?:\?(.*))?$/i.exec(href || '');
    if (!m) return '';
    var addr = decodeURIComponent(m[1]).trim().toLowerCase();
    if (!/@herolink\.com$/.test(addr)) return '';
    var who = addr.split('@')[0], subject = '';
    try { subject = new URLSearchParams(m[2] || '').get('subject') || ''; } catch (e) {}
    var box = /^(sales|wholesale)$/.test(who) ? 'sales' : /^(orgs|agencies|training)$/.test(who) ? 'orgs' : /^(partners?|partnerships)$/.test(who) ? 'partner'
      : /^(press|media)$/.test(who) ? 'press' : /^(sokeefe|careers|jobs|hr)$/.test(who) ? 'careers' : 'support';
    var here = (HERE[box] || []).filter(function (s) { return document.querySelector(s); })[0];
    if (here) return path + location.search + here;
    if (box === 'sales' || box === 'orgs') return BULK;
    if (box === 'partner') return contact('partner', subject);
    if (box === 'press') return contact('press', subject);
    if (box === 'careers') return '/pages/careers-application';
    if (/\/pages\/warranty/.test(path)) return '/pages/warranty-refunds#hl-warranty-claim';
    return contact('support', subject, reasonFor());
  }

  function fix(root) {
    (root || document).querySelectorAll('a[href^="mailto:" i]:not([data-hl-mailto-keep])').forEach(function (a) {
      var to = target(a.getAttribute('href'));
      if (!to) return;
      a.setAttribute('data-hl-mailto', a.getAttribute('href'));
      a.setAttribute('href', to);
      a.removeAttribute('target');
    });
  }
  fix();
  document.addEventListener('DOMContentLoaded', function () { fix(); });
  // links added later (cart drawer, popups, script-built content)
  new MutationObserver(function (list) { list.forEach(function (r) { r.addedNodes.forEach(function (n) { if (n.nodeType === 1) fix(n.matches && n.matches('a') ? n.parentNode : n); }); }); })
    .observe(document.documentElement, { childList: true, subtree: true });

  // same page: open the right Contact tab / scroll to the form without reloading
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-hl-mailto]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var u = new URL(a.href, location.href);
    if ((u.pathname.replace(/\/$/, '') || '/') !== path) return;
    var el = u.hash && document.querySelector(u.hash);
    if (!el) return;
    e.preventDefault();
    var topic = u.searchParams.get('topic'), tab = topic && document.querySelector('[data-hl-tab="' + topic + '"]');
    if (tab) tab.click();
    var reason = u.searchParams.get('reason'), sel = reason && document.querySelector('[data-hl-panel="' + topic + '"] select[data-reason]');
    if (sel && Array.prototype.some.call(sel.options, function (o) { return o.value === reason; })) { sel.value = reason; sel.dispatchEvent(new Event('change', { bubbles: true })); }
    var box = (el.closest('[data-hl-panel], section') || el);
    box.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();
